<template>
  <div class="cashflow column align-center">
    <div class="tab row">
      <div @click="tab = false" :class="!tab && 'active'">FLUXO DE CAIXA</div>
      <div @click="tab = true" :class="tab && 'active'">LANÇAMENTOS EXTRAORDINÁRIOS</div>
    </div>
    <template v-if="!tab">
      <div class="head row align-center column-s grid-11">
        <form
          class="filters row grid-12 column-s align-end"
          onsubmit="return false"
          @submit="loadChart()"
        >
          <div class="fil grid-2 grid-12-s column">
            <label>Data de referência</label>
            <input
              v-model="filters.data"
              type="date"
              class="input"
              placeholder="Inicio Pagamento"
              required
            />
          </div>
          <div class="fil grid-2 grid-12-s column">
            <label>Agrupamento</label>
            <select v-model="filters.agrupamento_data" class="input" required>
              <option :value="null">Selecione</option>
              <option value="dia">Dia</option>
              <option value="mes">Mês</option>
            </select>
          </div>
          <div class="fil grid-2 grid-12-s column">
            <label>Projeção</label>
            <select v-model="filters.projecao" class="input" required>
              <option :value="null">Selecione</option>
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>
          <div class="fil grid-2 grid-12-s column">
            <label>Extraordinário</label>
            <select v-model="filters.extraordinario" class="input" required>
              <option :value="null">Selecione</option>
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
          </div>

          <div class="fil grid-2 grid-12-s column">
            <label>Saldo Inicial</label>
            <Money
              v-model="filters.saldo_inicial"
              placeholder="Saldo Inicial"
              v-bind="money"
              required
            />
          </div>
          <div class="fil grid-2-g grid-3-m grid-12-s row justify-end justify-center-s">
            <Button layout="green-go" type="submit" :loader="loader"
              ><i class="fa-solid fa-chart-bar" /> GERAR</Button
            >
          </div>
        </form>
      </div>
      <div v-if="chartdata.data.datasets.length" id="charts" class="list grid-11">
        <Chart :chart="chartdata" />
        <div class="numbers row justify-around column-s">
          <div class="card gain grid-3 grid-11-s row wrap">
            <div class="grid-12 title text-center">FATURAMENTO (R$)</div>
            <div class="grid-6">
              Real<br />Projetado<br />Extra<br /><br /><br /><b> TOTAL </b>
            </div>
            <div class="grid-6 text-right bold">
              {{ chart.faturamento.real | money }}<br />
              {{ chart.faturamento.projetado | money }}<br />
              {{ chart.faturamento.extra | money }}<br /><br />
              <b>{{ chart.faturamento.total | money }}</b>
            </div>
          </div>
          <div class="card pay grid-3 grid-11-s row wrap">
            <div class="grid-12 title text-center">PAGAMENTO (R$)</div>
            <div class="grid-6">
              Real<br />Projetado<br />Extra<br /><br /><br /><b> TOTAL </b>
            </div>
            <div class="grid-6 text-right bold">
              {{ chart.pagamento.real | money }}<br />
              {{ chart.pagamento.projetado | money }}<br />
              {{ chart.pagamento.extra | money }}<br /><br />
              <b>{{ chart.pagamento.total | money }}</b>
            </div>
          </div>
          <div class="card total grid-3 grid-11-s row wrap text-center">
            <div class="grid-12 title">SALDO FINAL (R$)</div>
            <b class="grid-12 bold">
              {{ chart.saldo_final | money }}
            </b>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="head row align-center column-s grid-11 justify-center">
        <div class="filters row column-s align-end">
          <div class="fil grid-3 grid-12-s column">
            <label>Inicio Pagamento</label>
            <input
              v-model="filtersEntry.data_inicio"
              type="date"
              class="input"
              placeholder="Data Inicio"
            />
          </div>
          <div class="fil grid-3 grid-12-s column">
            <label>Fim Pagamento</label>
            <input
              v-model="filtersEntry.data_fim"
              type="date"
              class="input"
              placeholder="Data Fim"
            />
          </div>
          <div class="row">
            <Button layout="green-go" @click="loadEntry()" :loader="loader"
              ><i class="fa fa-clipboard-list" /> LISTAR</Button
            >

            <Button
              :layout="showForm ? 'red-go' : 'green-go'"
              title="NOVO LAÇAMENTO"
              @click="showForm = !showForm"
              >{{ showForm ? "x FECHAR" : "+ LANÇAR" }}
            </Button>
          </div>
        </div>
      </div>

      <transition name="slide">
        <div v-if="showForm" class="new grid-11">
          <EntryForm :form="form" />
        </div>
      </transition>

      <div v-if="list.length" class="list grid-11">
        <template v-if="list.length">
          <div class="sub row">
            <input class="input search" v-model="search" placeholder="Pesquisar" />
            <div class="row grid-8 justify-end">
              <div class="grid-2 column grid-12-s text-center-s">
                Lançamentos <b>{{ list.length }}</b>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="th row justify-space">
              <div class="grid-2">Data</div>
              <div class="grid-2">Tipo</div>
              <div class="grid-2">Valor</div>
              <div class="grid-6">Observações</div>
            </div>

            <div class="content">
              <div v-for="(item, i) of filtered" :key="'item' + i">
                <div class="line row justify-space" @click="toggle(i)">
                  <div class="grid-2">{{ item.data | date }}</div>
                  <div class="grid-2">{{ item.tipo }}</div>
                  <div class="grid-2">{{ item.lancamento | money }}</div>
                  <div class="grid-6">{{ item.observacao }}</div>
                </div>
                <div class="edit" v-if="item.show">
                  <div class="row justify-end">
                    <div
                      @click="item.show = false"
                      class="close text-red font-30 bold pointer"
                      title="FECHAR"
                    >
                      x
                    </div>
                  </div>
                  <EntryForm :form="item" />
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="text-center"><br /><br />Não possui lançamentos.</div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Chart from "@/components/Chart.vue";
import Button from "@/components/Button.vue";
import { Money } from "v-money";
import EntryForm from "@/views/admin/components/EntryForm.vue";

export default {
  name: "CashFlow",
  components: {
    Button,
    Chart,
    Money,
    EntryForm,
  },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      tab: false,
      loader: false,

      filters: {
        data: "",
        agrupamento_data: null,
        projecao: null,
        extraordinario: null,
        saldo_inicial: 0,
      },
      search: "",
      filtersEntry: {
        data_inicio: "",
        data_fim: "",
      },
      showForm: false,
      form: {
        tipo: "",
        send: this.send,
      },
      list: [],
      chart: {},
      chartdata: {
        type: "bar",
        data: {
          labels: [],
          datasets: [],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      },
    };
  },
  methods: {
    ...mapActions("admin", [
      "CASHFLOW_GENERATE",
      "ENTRY_LIST",
      "ENTRY_NEW",
      "ENTRY_UPDATE",
      "ENTRY_DEL",
      "ENTRY_GET",
    ]),
    async loadEntry() {
      this.loader = true;

      await this.ENTRY_LIST(this.filtersEntry)
        .then(({ data }) => {
          this.list = data || [];
          this.loader = false;
        })
        .catch(() => (this.loader = false));
      this.form = { send: this.send };
      this.loader = false;
    },
    async loadChart() {
      this.loader = true;
      const chartinfo = {
        pag_ext: [],
        pag_proj: [],
        pag_real: [],
        fat_ext: [],
        fat_proj: [],
        fat_real: [],
        saldo: [],
      };

      await this.CASHFLOW_GENERATE(this.filters)
        .then(({ data }) => {
          if (data.fluxo_caixa) {
            this.chart = data;
            this.chartdata.data.labels = [];
            data.fluxo_caixa.map((item) => {
              this.chartdata.data.labels.push(item.periodo);
              chartinfo.pag_ext.push(item.pag_ext);
              chartinfo.pag_proj.push(item.pag_proj);
              chartinfo.pag_real.push(item.pag_real);
              chartinfo.fat_proj.push(item.fat_proj);
              chartinfo.fat_real.push(item.fat_real);
              chartinfo.fat_ext.push(item.fat_ext);
              chartinfo.saldo.push(item.saldo);
            });

            this.chartdata.data.datasets = [
              {
                type: "line",
                label: "Saldo",
                borderColor: "#333",
                backgroundColor: "transparent",
                borderWidth: 2,
                data: chartinfo.saldo,
                stack: "Stack 0",
              },
              {
                type: "bar",
                label: "Pag Real",
                backgroundColor: "#d61647",
                data: chartinfo.pag_real,
                stack: "Stack 0",
              },

              {
                type: "bar",
                label: "Pag Proj",
                backgroundColor: "#f06f2b",
                data: chartinfo.pag_proj,
                stack: "Stack 0",
              },
              {
                type: "bar",
                label: "Pag Ext",
                backgroundColor: "#f06060",
                data: chartinfo.pag_ext,
                stack: "Stack 0",
              },
              {
                type: "bar",
                label: "Fat Real",
                backgroundColor: "#74a155",
                data: chartinfo.fat_real,
                stack: "Stack 0",
              },
              {
                type: "bar",
                label: "Fat Proj",
                backgroundColor: "#90bf01",
                data: chartinfo.fat_proj,
                stack: "Stack 0",
              },
              {
                type: "bar",
                label: "Fat Ext",
                backgroundColor: "#adca53",
                data: chartinfo.fat_ext,
                stack: "Stack 0",
              },
            ];

            document.updateChart();

            setTimeout(function () {
              window.scrollTo({
                top: document.getElementById("charts").offsetTop,
                behavior: "smooth",
              });
            }, 800);
          }
        })
        .catch(() => (this.loader = false));

      this.loader = false;
    },
    async del(item) {
      if (confirm(`Deseja excluir o lançamento?`)) {
        return this.ENTRY_DEL(item.id).then(() => this.loadEntry());
      }
    },
    async update(item) {
      return this.ENTRY_UPDATE({ ...item, params: item.id }).then(({ status }) => {
        if (status == 200) this.loadEntry();
      });
    },
    async send(form) {
      return this.ENTRY_NEW(form).then(() => this.loadEntry());
    },
    async toggle(index) {
      this.list[index].show = !this.list[index].show;

      if (this.list[index].show) {
        await this.ENTRY_GET(this.list[index].id).then(({ data }) => {
          this.list[index].update = true;
          this.list[index].send = () => this.update(this.list[index]);
          this.list[index].del = () => this.del(this.list[index]);
          this.list[index] = { ...this.list[index], ...data };
          this.list = [...this.list];
        });
      }
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("cashflow");
  },
  computed: {
    filtered() {
      if (this.search) {
        const search = this.search.toLowerCase();
        return this.list.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.list;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/assets/scss/vars.scss"
.cashflow
    @include page
    @include tab
    .head
      background: white
      padding: 16px 21px
      padding-top: 40px
      border-radius: 21px
      margin-top: -5px
      @include border
      border-top: none
    #charts
      #chart
        max-height: 600px
    .th
      @include label
    .new
      margin-top: 21px
      @include card
    .numbers
        margin-top:17px
    .edit
      .close
        margin-top: -21px
        margin-right: 7px
    .card
      border-radius: 17px
      padding: 17px 19px
      .title
        padding-bottom: 13px
        padding-top: 7px
        font-size: 13px
        font-weight: bold
        letter-spacing: 1.4px
      .bold
        font-size: 21px
      &.b
        background-color: $font-color
      &.pay
        background-color: #d61647
        color: $red-6
      &.gain
        background-color: #74a155
        color: white
      &.total
        color: #444
        background-color: $white-1
</style>
